'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contextualNodeAttributes"];
import tinymce from 'tinymce';
import { OLAF } from 'HubStyleTokens/colors';
import ColorPickerToolbarButton from 'rich-text-lib/components/toolbar/ColorPickerToolbarButton';
import { BackgroundColorIcon } from 'foundations-assets';
import { getColorPicker } from '../../../components/ColorPicker';
import { CANVAS_FILL_COLOR } from '../../../constants/toolbar';
import { jsx as _jsx } from "react/jsx-runtime";
export function addContextualFillColorControl(editor) {
  const handleColorChange = (target, color) => {
    editor.fire('hsFillColorChange', {
      target,
      color
    });
  };
  const ColorPicker = getColorPicker(editor, {
    includeAlpha: false
  });
  const renderColorPicker = renderProps => {
    // Alpha defaults to 0 when there is no `fillColor`
    const showResetToDefault = renderProps.alpha !== 0;
    return /*#__PURE__*/_jsx(ColorPicker, Object.assign({}, renderProps, {
      showResetToDefault: showResetToDefault
    }));
  };
  tinymce.canvas.addButton(editor, CANVAS_FILL_COLOR, {
    renderControl: props => {
      const {
          contextualNodeAttributes
        } = props,
        rest = _objectWithoutPropertiesLoose(props, _excluded);
      const {
        fillColor,
        fillColorTooltip,
        activeElement
      } = contextualNodeAttributes;
      return /*#__PURE__*/_jsx(ColorPickerToolbarButton, Object.assign({
        "data-test-id": "color-picker-fillcolor",
        tooltip: fillColorTooltip,
        icon: "backgroundColor",
        Icon: BackgroundColorIcon,
        color: fillColor,
        defaultColor: OLAF,
        defaultAlpha: 0,
        onColorChange: handleColorChange.bind(null, activeElement),
        dropdownClassName: "mce-hubspot-popover",
        renderColorPicker: renderColorPicker
      }, rest));
    }
  });
}